import React, { useContext, useState } from 'react';
import styled from 'styled-components';
import { Button, Menu, MenuItem } from '@material-ui/core';
import { ReportContext } from '../Context/ReportContext';
import defaults from '../translations/en.json';
const ButtonHeaderContainer = styled.div.withConfig({
  displayName: "HeaderButtons__ButtonHeaderContainer",
  componentId: "qhe4pu-0"
})(["margin-left:auto;margin-top:auto;margin-bottom:auto;display:flex;"]);
const ButtonContainer = styled.div.withConfig({
  displayName: "HeaderButtons__ButtonContainer",
  componentId: "qhe4pu-1"
})(["padding:5px;"]);
export const HeaderButtons = ({
  reportHeader
}) => {
  const {
    reportData,
    showLoader,
    runReport,
    exportReportAsCSV
  } = useContext(ReportContext);
  const disableSubmit = showLoader;
  const disableDownload = showLoader || !reportData;
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const options = [{
    name: defaults.saveAsCSV,
    onClick: exportReportAsCSV
  }];

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return /*#__PURE__*/React.createElement(ButtonHeaderContainer, null, /*#__PURE__*/React.createElement(ButtonContainer, null, /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    variant: "contained",
    size: "small",
    disabled: disableSubmit,
    onClick: () => runReport(reportHeader.shortName),
    color: "primary",
    style: {
      padding: '5px'
    }
  }, defaults.generateReport)), /*#__PURE__*/React.createElement(ButtonContainer, null, /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    variant: "contained",
    size: "small",
    disabled: disableDownload,
    onClick: handleClick,
    color: "primary",
    style: {
      padding: '5px'
    }
  }, defaults.downloadReport), /*#__PURE__*/React.createElement(Menu, {
    id: "basic-menu",
    anchorEl: anchorEl,
    open: open,
    onClose: handleClose,
    MenuListProps: {
      'aria-labelledby': 'basic-button'
    }
  }, options.map(({
    name,
    onClick
  }) => /*#__PURE__*/React.createElement(MenuItem, {
    onClick: onClick
  }, name)))));
};